import { render, staticRenderFns } from "./homeDetail.vue?vue&type=template&id=961ba7e6&scoped=true"
import script from "./homeDetail.vue?vue&type=script&lang=js"
export * from "./homeDetail.vue?vue&type=script&lang=js"
import style0 from "./homeDetail.vue?vue&type=style&index=0&id=961ba7e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ba7e6",
  null
  
)

export default component.exports